export const lobConstants = {
    CURRENT_LOB_SET: "CURRENT_LOB_SET",
    LOB_CLEAR: "LOB_CLEAR"
  };
  